(function (window, document) {
    'use strict';

    var desktopQuery = window.matchMedia('(min-width: 992px)');
    var header = document.querySelector('[data-public-navigation-header]');
    var surface = document.querySelector('[data-public-navigation-surface]');
    var activePage = surface && surface.querySelector('[data-public-navigation-page].is-public-navigation-active');
    var isNavigating = false;
    var navigationCount = 0;
    var transitionDuration = 130;
    var supportedPaths = surface ? parseSupportedPaths(surface.getAttribute('data-public-navigation-paths')) : [];

    function parseSupportedPaths(value) {
        try {
            var paths = JSON.parse(value || '[]');

            return Array.isArray(paths) ? paths : [];
        } catch (error) {
            return [];
        }
    }

    function currentPath() {
        return surface && surface.getAttribute('data-public-navigation-path');
    }

    function isSupportedUrl(url) {
        return url.origin === window.location.origin
            && !url.search
            && !url.hash
            && supportedPaths.indexOf(url.pathname) !== -1;
    }

    function isNavigationReady() {
        return Boolean(header && surface && activePage && isSupportedUrl(new URL(window.location.href)));
    }

    function reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function wait(milliseconds) {
        return new Promise(function (resolve) {
            window.setTimeout(resolve, milliseconds);
        });
    }

    function nextFrame() {
        return new Promise(function (resolve) {
            window.requestAnimationFrame(function () {
                window.requestAnimationFrame(resolve);
            });
        });
    }

    function saveCurrentHistoryState() {
        var existingState = history.state && typeof history.state === 'object' ? history.state : {};
        var nextState = Object.assign({}, existingState, {
            iksonPublicNavigation: {
                path: currentPath(),
                scrollX: window.pageXOffset,
                scrollY: window.pageYOffset
            }
        });

        history.replaceState(nextState, '', window.location.href);
    }

    function pushDestinationHistory(url) {
        history.pushState({
            iksonPublicNavigation: {
                path: url.pathname,
                scrollX: 0,
                scrollY: 0
            }
        }, '', url.pathname);
    }

    function trackCommittedPageview() {
        if (window.fathom && typeof window.fathom.trackPageview === 'function') {
            try {
                window.fathom.trackPageview();
            } catch (error) {
                // Analytics must never interrupt a committed public navigation.
            }
        }
    }

    function parseDestination(html, expectedPath) {
        var destinationDocument = new DOMParser().parseFromString(html, 'text/html');
        var destinationSurface = destinationDocument.querySelector('[data-public-navigation-surface]');
        var destinationHeader = destinationDocument.querySelector('[data-public-navigation-header]');
        var destinationPage = destinationSurface && destinationSurface.querySelector('[data-public-navigation-page]');
        var canonical = destinationDocument.querySelector('link[rel="canonical"]');
        var description = destinationDocument.querySelector('meta[name="description"]');

        if (!destinationSurface
            || !destinationHeader
            || !destinationPage
            || destinationSurface.getAttribute('data-public-navigation-path') !== expectedPath
            || !destinationDocument.title
            || !canonical
            || !description) {
            return null;
        }

        return {
            page: destinationPage,
            header: destinationHeader,
            path: expectedPath,
            title: destinationDocument.title,
            canonical: canonical.getAttribute('href'),
            description: description.getAttribute('content')
        };
    }

    function copyNavigationState(destinationHeader) {
        var liveLinks = header.querySelectorAll('a[href]');
        var destinationLinks = destinationHeader.querySelectorAll('a[href]');
        var destinationLinkState = {};

        Array.prototype.forEach.call(destinationLinks, function (link) {
            var href = new URL(link.href, window.location.href).href;

            destinationLinkState[href] = destinationLinkState[href] === true || link.classList.contains('active');
        });

        Array.prototype.forEach.call(liveLinks, function (link) {
            var isActive = destinationLinkState[new URL(link.href, window.location.href).href] === true;

            link.classList.toggle('active', isActive);

            if (isActive) {
                link.setAttribute('aria-current', 'page');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    }

    function applyHeader(destinationHeader) {
        header.className = destinationHeader.className;
        header.setAttribute('data-public-navigation-route', destinationHeader.getAttribute('data-public-navigation-route') || '');
    }

    function updateMetadata(destination) {
        var liveCanonical = document.querySelector('link[rel="canonical"]');
        var liveDescription = document.querySelector('meta[name="description"]');

        document.title = destination.title;
        liveCanonical.setAttribute('href', destination.canonical);
        liveDescription.setAttribute('content', destination.description);
    }

    function refreshRouteBehaviors() {
        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
            window.AOS.refreshHard();
        }
    }

    function syncPageClasses(path) {
        document.body.classList.toggle('music-library-page', path === '/music');
    }

    function resetMusicPlayerWhenLeavingMusic(nextPath) {
        if (currentPath() !== '/music' || nextPath === '/music') {
            return;
        }

        if (window.iksonPlayer && typeof window.iksonPlayer.stopAndReset === 'function') {
            window.iksonPlayer.stopAndReset();
        }
    }

    function setScrollPosition(position) {
        var documentRoot = document.documentElement;
        var previousScrollBehavior = documentRoot.style.scrollBehavior;

        documentRoot.style.scrollBehavior = 'auto';
        window.scrollTo(position.scrollX || 0, position.scrollY || 0);
        documentRoot.style.scrollBehavior = previousScrollBehavior;
        window.dispatchEvent(new Event('scroll'));
    }

    function focusDestination() {
        var focusTarget = activePage.querySelector('h1, h2, h3');

        if (focusTarget) {
            focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus({ preventScroll: true });
            return;
        }

        surface.focus({ preventScroll: true });
    }

    function imageUrl(value) {
        var match = /url\(["']?([^"')]+)["']?\)/.exec(value || '');

        return match ? match[1] : null;
    }

    function waitForImage(url) {
        return new Promise(function (resolve) {
            var image = new window.Image();

            image.onload = function () {
                resolve(true);
            };
            image.onerror = function () {
                resolve(false);
            };
            image.src = url;

            if (image.complete) {
                resolve(image.naturalWidth > 0);
            }
        });
    }

    function waitForCriticalVisuals(page) {
        var urls = [];
        var atmosphere = page.querySelector('.music-library-atmosphere');
        var atmosphereImage;

        Array.prototype.forEach.call(page.querySelectorAll('.release-hero__media img, .music-library-atmosphere__identity img'), function (image) {
            if (image.currentSrc || image.src) {
                urls.push(image.currentSrc || image.src);
            }
        });

        if (atmosphere) {
            atmosphereImage = imageUrl(window.getComputedStyle(atmosphere).getPropertyValue('--music-library-atmosphere-image'));

            if (atmosphereImage) {
                urls.push(atmosphereImage);
            }
        }

        urls = urls.filter(function (url, index) {
            return urls.indexOf(url) === index;
        });

        if (urls.length === 0) {
            return Promise.resolve(true);
        }

        return Promise.all(urls.map(waitForImage)).then(function (results) {
            return results.every(Boolean);
        });
    }

    function prepareDestination(destination) {
        var incomingPage = document.importNode(destination.page, true);

        incomingPage.classList.remove('is-public-navigation-active');
        incomingPage.classList.add('is-public-navigation-incoming', 'is-public-navigation-preparing');
        incomingPage.setAttribute('aria-hidden', 'true');
        surface.appendChild(incomingPage);

        return nextFrame().then(function () {
            return waitForCriticalVisuals(incomingPage);
        }).then(function (criticalVisualsReady) {
            if (!criticalVisualsReady) {
                incomingPage.remove();
                throw new Error('The destination visual is unavailable.');
            }

            return incomingPage;
        });
    }

    function finishTransition(incomingPage, destination, scrollPosition) {
        activePage.remove();
        incomingPage.classList.remove('is-public-navigation-incoming', 'is-public-navigation-preparing', 'is-public-navigation-entering', 'is-public-navigation-entered');
        incomingPage.classList.add('is-public-navigation-active');
        incomingPage.removeAttribute('aria-hidden');
        activePage = incomingPage;
        surface.classList.remove('is-public-navigation-transitioning');
        surface.setAttribute('data-public-navigation-path', destination.path);
        surface.setAttribute('data-public-navigation-route', destination.header.getAttribute('data-public-navigation-route') || '');
        surface.removeAttribute('aria-busy');
        updateMetadata(destination);
        copyNavigationState(destination.header);
        syncPageClasses(destination.path);
        refreshRouteBehaviors();
        focusDestination();
        setScrollPosition(scrollPosition);
    }

    function transitionTo(destination, incomingPage, scrollPosition) {
        var outgoingPage = activePage;
        var immediate = reducedMotion();

        resetMusicPlayerWhenLeavingMusic(destination.path);
        setScrollPosition(scrollPosition);
        surface.setAttribute('aria-busy', 'true');
        applyHeader(destination.header);
        outgoingPage.setAttribute('aria-hidden', 'true');
        incomingPage.removeAttribute('aria-hidden');
        surface.classList.add('is-public-navigation-transitioning');
        outgoingPage.classList.add('is-public-navigation-outgoing');
        incomingPage.classList.remove('is-public-navigation-preparing');
        incomingPage.classList.add('is-public-navigation-entering');

        return nextFrame().then(function () {
            incomingPage.classList.add('is-public-navigation-entered');
            outgoingPage.classList.add('is-public-navigation-left');

            return immediate ? Promise.resolve() : wait(transitionDuration);
        }).then(function () {
            finishTransition(incomingPage, destination, scrollPosition);
        });
    }

    function fallbackToDocumentNavigation(url, isHistoryNavigation) {
        if (isHistoryNavigation) {
            window.location.reload();
            return;
        }

        window.location.assign(url.href);
    }

    function loadDestination(url) {
        return window.fetch(url.href, {
            credentials: 'same-origin',
            headers: {
                'Accept': 'text/html'
            }
        }).then(function (response) {
            if (!response.ok || response.redirected) {
                throw new Error('The destination response cannot be enhanced.');
            }

            return response.text();
        }).then(function (html) {
            var destination = parseDestination(html, url.pathname);

            if (!destination) {
                throw new Error('The destination response is not a supported public page.');
            }

            return destination;
        });
    }

    function navigate(url, options) {
        var isHistoryNavigation = options && options.history === 'pop';
        var scrollPosition = isHistoryNavigation ? options.scrollPosition : { scrollX: 0, scrollY: 0 };

        if (!isSupportedUrl(url) || !isNavigationReady() || isNavigating) {
            fallbackToDocumentNavigation(url, isHistoryNavigation);
            return;
        }

        isNavigating = true;

        loadDestination(url).then(function (destination) {
            if (!isHistoryNavigation) {
                saveCurrentHistoryState();
            }

            return prepareDestination(destination).then(function (incomingPage) {
                return transitionTo(destination, incomingPage, scrollPosition);
            }).then(function () {
                if (!isHistoryNavigation) {
                    pushDestinationHistory(url);
                }

                trackCommittedPageview();
                navigationCount += 1;
            });
        }).catch(function () {
            fallbackToDocumentNavigation(url, isHistoryNavigation);
        }).finally(function () {
            isNavigating = false;
        });
    }

    function onDocumentClick(event) {
        var link = event.target.closest('a[href]');

        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        if (link.closest('form') || link.hasAttribute('target') || link.hasAttribute('download')) {
            return;
        }

        var url = new URL(link.href, window.location.href);

        if (!desktopQuery.matches || !isSupportedUrl(url) || url.pathname === currentPath()) {
            return;
        }

        event.preventDefault();

        if (isNavigating) {
            return;
        }

        navigate(url, { history: 'push' });
    }

    function onPopState(event) {
        var url = new URL(window.location.href);
        var navigationState = event.state && event.state.iksonPublicNavigation;

        if (!desktopQuery.matches
            || !isSupportedUrl(url)
            || !navigationState
            || navigationState.path !== url.pathname
            || url.pathname === currentPath()) {
            return;
        }

        navigate(url, {
            history: 'pop',
            scrollPosition: {
                scrollX: navigationState.scrollX || 0,
                scrollY: navigationState.scrollY || 0
            }
        });
    }

    function init() {
        if (!isNavigationReady()) {
            return;
        }

        if (desktopQuery.matches && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        saveCurrentHistoryState();
        document.documentElement.classList.add('ikson-public-navigation-enabled');
        document.addEventListener('click', onDocumentClick);
        window.addEventListener('popstate', onPopState);

        window.iksonPublicNavigation = {
            diagnostics: function () {
                return {
                    headerIsPersistent: header === document.querySelector('[data-public-navigation-header]'),
                    navigationCount: navigationCount,
                    activePath: currentPath()
                };
            }
        };
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})(window, document);
